export default __webpack_public_path__ + "static/media/girl-with-headphones-concerned.0ea25518.png";